// extracted by mini-css-extract-plugin
module.exports = {"b2bFeatures":"_3uigbaiUSrRZ8mUJObAZSx","b2bFeatures__block":"_1RQDwoBbJjudH7o8omtyyt"};